import { Component } from '@angular/core'
import { LegalSystemsService } from './services/legal-systems.service'
import { Observable } from 'rxjs'
import { SharedHeader } from './shared/legal-system.model'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  header$!: Observable<SharedHeader>
  isMenuOpen = false

  constructor (private legal: LegalSystemsService) {
    this.header$ = this.legal.getSharedHeader('header')
  }

  ngOnInit (): void {}
}
